module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "bird",
      "src": "image/bird.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "center"
  }, [_vm._v("EARLY BIRD BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("FRESH EBOOK DEALS, DELIVERED DAILY")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("LOVE  "), _c('span', {
    staticClass: "Orange-Text-1"
  }, [_vm._v("TO READ")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("LOVE "), _c('span', {
    staticClass: "Orange-Text-1"
  }, [_vm._v("GREAT SALES")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-2",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("GET "), _c('span', {
    staticClass: "Orange-Text-1"
  }, [_vm._v("FANTASTIC")]), _vm._v(" DEALS ON BESTSELLING EBOOKS DELIVERED TO YOUR INBOX EVERY DAY!")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://earlybirdbooks.com/?utm_source=EBBGOAAAAE&utm_campaign=9781504041249",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "signup",
      "src": "image/signup.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50def0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ebadfront.vue
// module id = 57
// module chunks = 0